import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-change-money',
  templateUrl: './change-money.component.html',
  styleUrls: ['./change-money.component.less']
})
export class ChangeMoneyComponent implements OnInit {

  @Input() valueText = '';

  @Input() isModalVisible: boolean;
  @Input() isCloseable: boolean = true;
  @Output() isModalVisibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() onClickConfirm = new EventEmitter<any>();
  @Output() onCloseModal = new EventEmitter<any>();

  onClickButton(event) {
    this.onClickConfirm.emit(event);
  }

  closeModal(event) {
    this.onCloseModal.emit(event);
  }

  constructor() { }

  ngOnInit(): void { }

}
